import React from "react";
import "../../../../css/Common/Components/DesignSystem/Buttons.css";

// ButtonGreen is a React component for rendering a green-styled button.
// It manages its own clicked state and calls an onClick handler passed via props.
class ButtonGreen extends React.Component {
  constructor() {
    super();

    // Initialize component state
    this.state = {
      clicked: false,      // Tracks if the button has been clicked
      greenClicked: false, // Unused state, possibly for future use
    };
  }

  render() {
    // Destructure buttonText and onClick from props
    const { buttonText, onClick } = this.props;
    return (
      <div
        // Apply CSS classes conditionally based on greenClicked state
        className={`Button-Brand2 ${this.state.greenClicked ? "clicked" : ""}`}
        onClick={() => {
          // Toggle the clicked state when the button is clicked
          this.setState({ clicked: !this.state.clicked });
          onClick(); // Call the onClick prop function
        }}
      >
        {/* Render the button text */}
        <div className="Button-Text">{buttonText}</div>
      </div>
    );
  }
}

export default ButtonGreen;
